<template>
  <div>
    <div class="modal-mask">
      <div class="modal-content-container" id="newProductModalBody">
        <div class="ressuply-products__header-container">
          <span class="ressuply-products__header-title not-print">
            Adicionar Produtos na Requisição {{ quotation }}
          </span>

          <div style="display: flex">
            <img
              :src="
                whitelabel ? whitelabel.data.imgs.img_logo : require('@/assets/logo.png')
              "
              style="width: 135px; height: 70px; margin-right: 25px"
              alt=""
              class="show-print"
            />
          </div>

          <span
            @click="closeDialog"
            class="material-icons ressuply-products__closebtn-icon"
          >
            cancel
          </span>
        </div>
        <div class="ressuply-products__actions__div2-container">
          <div class="ressuply-products__search-product__container">
            <div class="ressuply-products__search-product__search-wrapper">
              <span class="ressuply-products__search-product__search-title">
                Buscar Produto
              </span>
            </div>
            <div class="ressuply-products__search-product__input-wrapper">
              <div class="ressuply-products__search-product__input-container">
                <input
                  placeholder="Digite o nome do produto"
                  v-model="product_name_filter"
                  @keyup="searchProduct()"
                  class="ressuply-products__search-product__search-input"
                  type="text"
                />
                <span
                  @click="searchProduct()"
                  class="material-icons ressuply-products__search-product__search-icon"
                >
                  search
                </span>
              </div>
              <div class="ressuply-products__actions__div2-container">
                <div
                  @click="showNewProductModal = true"
                  class="ressuply-products__actions__wrapper"
                >
                  <span class="material-icons ressuply-products__actions-icon">
                    add_circle
                  </span>
                  <span class="ressuply-products__actions-title"> Novo Produto </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <cc-loader-full v-if="loading" />
        <div>
          <div>
            <div class="ressuply-products__table2-container">
              <table class="ressuply-products__table-wrapper">
                <thead class="ressuply-products__table-thead desktop">
                  <tr class="ressuply-products__table-thead-tr">
                    <td class="ressuply-products__table-td">Código</td>
                    <td class="ressuply-products__table-td">Nome</td>
                    <td class="ressuply-products__table-td">Embalagem</td>
                    <template v-if="storeNumber">
                      <td class="ressuply-products__table-td">Estoque</td>
                      <td v-if="hasGiro" class="ressuply-products__table-td">Giro (un/dia)</td>
                      <td class="ressuply-products__table-td">Sugestão</td>
                    </template>
                    <td class="ressuply-products__table-td not-print">Quantidade</td>
                  </tr>
                </thead>
                <tbody class="ressuply-products__table-tbody">
                  <tr
                    v-for="(item, idx) in my_products"
                    :key="'prod-' + item.pro_id"
                    :class="getLineClass(item, idx)"
                    class="ressuply-products__table-tbody-tr"
                  >
                    <!-- desktop   -->
                    <td class="ressuply-products__table-td desktop">
                      {{ item.pro_ean }}
                    </td>
                    <td class="ressuply-products__table-td desktop">
                      {{ item.pro_descricao }}
                    </td>
                    <td class="ressuply-products__table-td desktop">
                      {{
                        item.pro_generico == 1
                          ? item.pro_unidade_compra
                          : item.pro_embalagem
                      }}
                    </td>
                    <template v-if="storeNumber">
                      <td class="ressuply-products__table-td desktop">
                        <span v-if="giroLoading" class="ressuply-products__giro-empty">…</span>
                        <span v-else-if="giroRow(item)">{{ formatGiroNumber(giroRow(item).stock) }}</span>
                        <span v-else class="ressuply-products__giro-empty">—</span>
                      </td>
                      <td v-if="hasGiro" class="ressuply-products__table-td desktop">
                        <span v-if="giroLoading" class="ressuply-products__giro-empty">…</span>
                        <span v-else-if="giroRow(item)">{{ formatGiroNumber(giroRow(item).giro) }}</span>
                        <span v-else class="ressuply-products__giro-empty">—</span>
                      </td>
                      <td class="ressuply-products__table-td desktop">
                        <span v-if="giroLoading" class="ressuply-products__giro-empty">…</span>
                        <span
                          v-else-if="giroRow(item)"
                          class="ressuply-products__giro-suggestion"
                          :title="`Cobertura prevista: ${formatGiroNumber(giroRow(item).coverage)} dias`"
                        >
                          {{ giroSuggestion(item) }}
                        </span>
                        <span v-else class="ressuply-products__giro-empty" :title="giroEmptyReason(item)">—</span>
                      </td>
                    </template>
                    <td class="ressuply-products__table-td not-print desktop">
                      <div class="ressuply-products__edit-amount-wrapper">
                        <input
                          min="0"
                          type="number"
                          :data-idx="idx"
                          ref="new-amount"
                          class="product-amount text-center w-25 not-print focused-input"
                          :class="{ active: item.saved }"
                          v-model.number="item.new_amount"
                          data-visible="true"
                          @keydown="handle_my_products_navigation($event, item)"
                          @blur="handle_my_products_navigation($event, item)"
                          :key="'qtd' + item.prod_id"
                        />
                        <span
                          @click="handle_my_products_navigation($event, item)"
                          class="material-icons ressuply-products__edit-amount-icon not-print"
                        >
                          add
                        </span>
                      </div>
                    </td>

                    <!-- mobile -->
                    <td class="mobile mobile-name-row">
                      {{ item.pro_descricao }}
                    </td>
                    <td class="mobile mobile-table-row">
                      <div>
                        <p class="mobile-table-title">Código</p>
                        {{ item.pro_ean }}
                      </div>
                      <div class="mobile-center">
                        <p class="mobile-table-title">Embalagem</p>
                        {{
                          item.pro_generico == 1
                            ? item.pro_unidade_compra
                            : item.pro_embalagem
                        }}
                      </div>
                      <div class="mobile-input-size mobile-end">
                        <p class="mobile-table-title">Quantidade</p>
                        <div class="ressuply-products__edit-amount-wrapper">
                          <input
                            min="0"
                            type="number"
                            :data-idx="idx"
                            class="product-amount text-center not-print focused-input"
                            :class="{ active: item.saved }"
                            v-model.number="item.new_amount"
                            data-visible="true"
                            @keydown="handle_my_products_navigation($event, item)"
                            @blur="handle_my_products_navigation($event, item)"
                            :key="'qtd' + item.prod_id"
                          />
                          <span
                            @click="handle_my_products_navigation($event, item)"
                            class="material-icons ressuply-products__edit-amount-icon not-print"
                          >
                            add
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="7">
                      <div class="footer" :key="'footer'">
                        <cc-pagination
                          :key="'pag'"
                          :items_by_page_value="items_by_page_value"
                          :total="total_items"
                          :page="page"
                          :page_limit="5"
                          classes="orange"
                          v-on:change="update_page($event)"
                        >
                        </cc-pagination>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ProductWrapModal
      v-if="open_edit_wrap && current_product"
      :product="current_product"
      @close="
        open_edit_wrap = false;
        getProducts();
      "
    />
    <new-product-modal
      v-if="showNewProductModal"
      :product="new_product || {}"
      :closeDialog="closeNewProductModal"
      :categories="[]"
      @emit_product="() => {}"
      @reload_products="getProducts"
      @close="closeNewProductModal"
    />
  </div>
</template>

<script>
import QuotationService from "@/services/QuotationService";
import RequestsService from "@/services/v2/requests.service";
import RequestsServiceV3 from "@/services/v3/request.service";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal";
import { elementNavigationmMixin } from "@/mixins/navigation.mixin";
import Pagination from "@/components/cliente/base-components/Pagination";
import { typingRemoteRequestControlMixin } from "@/mixins/typing-remote-request-controls.mixin";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import NewProductModal from "@/modals/new-product/new-product.modal";
import { perm_mixin } from "@/mixins/permission.mixin";
import { mapState } from "vuex";
import MiraiService, { buildSuggestionAlgoritmo, suggestionCodeKey, suggestionQuantity } from "@/services/MiraiService";

export default {
  components: {
    ProductWrapModal,
    ccPagination: Pagination,
    StandardInput,
    "new-product-modal": NewProductModal,
  },
  mixins: [
    elementNavigationmMixin,
    typingRemoteRequestControlMixin,
    loaderMixin,
    perm_mixin,
  ],
  props: ["quotation", "closeDialog", "item", "storeNumber", "clientId"],
  data() {
    return {
      focused: false,
      products: [],
      savedProducts: [],
      loading: true,
      open_edit_wrap: false,
      showMore: false,
      new_product: null,
      showNewProductModal: false,
      directOrder: false,
      page: 1,
      my_products: [],
      my_categories: [{ value: undefined, text: "TODOS" }],
      productFilter: "",
      categoryFilter: "",
      product_name_filter: null,
      total_items: null,
      items_by_page_value: 30,
      editing: false,
      svc: new RequestsService(),
      searchTime: undefined,
      svc_v3: new RequestsServiceV3(),
      service: new QuotationService(),
      modal: {
        title: `Produtos de ressuprimento #${this.quotation}`,
        subtitle: "Gerencie os produtos de ressuprimento",
        icon_title: "fas fa-boxes",
        unpermitted_message: "Aceite o termo de consentimento para continuar.",
        permitted: true,
        cancel_text: "voltar",
        style: {
          width: "90%",
        },
      },
      showZeroQuantity: false,
      giroByCode: {},
      giroLoading: false,
      giroFailed: false,
      giroRequest: 0,
      hasGiro: false,
    };
  },
  mounted() {
    this.getProducts();
    this.load_my_products();
  },
  methods: {
    getSugestionPrice(item) {
      if (item.qtd_padrao - item.estoque > 0) {
        if (item.pro_generico) return item.qtd_padrao - item.estoque;
        return Math.round(
          (item.qtd_padrao - item.estoque) / item.pro_embalagem.split(" ")[1]
        );
      } else return 0;
    },
    saveQTD(item) {
      var quotationService = new QuotationService();
      return quotationService
        .updateQuotationProductAmount(this.quotation, item)
        .then(() => {
          if (item.estoqueChange) item.savedEstoque = true;
          if (item.QTDChange) item.saveQTD = true;
          this.$forceUpdate();
        });
    },
    getSpecialBackground(idx) {
      if (idx % 2 != 0) return "page-table-line-special";
    },
    toggle_my_products() {
      this.new_product = this.new_product ? null : {};
      /* if(this.new_product) {
                gsap.fromTo('.slot-1', { x: "0%" }, { x: "-120%", duration: 0.5, ease: "back.out(1)" })
                gsap.fromTo('.slot-2', { x: "120%" }, { x: "-100%", duration: 0.5, ease: "back.out(1)" })
			} else {
                gsap.fromTo('.slot-1', { x: "120%" }, { x: "0%", duration: 0.5, ease: "back.out(1)" })
                gsap.fromTo('.slot-2', { x: "0%" }, { x: "-220%", duration: 0.5, ease: "back.out(1)" })
			} */
      this.$forceUpdate();
    },
    add_product(prod) {
      let data = {
        quantidade: prod.new_amount,
        prod_id: prod.pro_id,
        flag_generico: prod.pro_generico,
      };

      if (isNaN(prod.new_amount) || prod.new_amount == prod.quantidade)
        return Promise.resolve();

      return this.svc.add_product_to_resupply_request(this.quotation, data).then(() => {
        prod.saved = true;
        const notification = {
          type: "success",
          message: "Produto adicionado com sucesso!",
        };
        this.$store.dispatch("notification/add", notification);
        prod.saved = true;
        prod.quantidade = prod.new_amount;
        this.savedProducts.push(prod);
        this.getProducts();
      });
    },
    handle_my_products_navigation($event, product) {
      this.navigate($event, {
        ref: "new-amount",
        callback: {
          function: this.add_product,
          params: product,
        },
      });
    },
    update_page(page) {
      this.page = page;
      this.load_my_products();
    },
    getProducts() {
      return this.service
        .getProductsResupply(this.quotation)
        .then((response) => response.data)
        .then((data) => {
          this.loading = false;
          this.products = data.produtos;
          this.products.forEach((p) => {
            p.new_amount = p.quantidade;
            this.savedProducts.forEach((element) => {
              if (element.pro_id == p.pro_id) p.saved = true;
            });
          });
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    searchProduct() {
      const time = new Date();
      this.searchTime = time;
      setTimeout(() => {
        if (this.searchTime == time) {
          this.page = 1;
          this.load_my_products();
        }
      }, 500);
    },
    load_my_products() {
      this.loading = true;

      this.cancelSearch(() => {
        this.loading = true;
      });
      const params = {
        nomeproduto: this.product_name_filter,
        page: this.page,
        deleted: 0,
      };
      this.service
        .getProdutosClientePorPagina(params, this.cancelSource?.token)
        .then((data) => {
          this.my_products = data.data.produtos.data;
          data.data.categorias.forEach((element) => {
            if (element.cat_excluido != "1" && element.cat_status != "0")
              this.my_categories.push({ value: element, text: element.cat_descricao });
          });

          this.page = data.data.produtos.current_page;
          setTimeout(() => {
            this.total_items = data.data.produtos.total;
          }, 200);
          //this.totalPaginas = data.data.produtos.last_page;
          this.products.forEach((v) => (v.expanded = false));
          this.loading = false;
          this.loadGiro();
        })
        .catch((error) => {
          this.loading = false;
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    update_one(product) {
      if (isNaN(product.quantidade) || product.new_amount == product.quantidade)
        return Promise.resolve();
      var quotationService = new QuotationService();
      return quotationService
        .updateQuotationProductAmount(this.quotation, {
          pro_id: product.pro_id,
          quantidade: product.new_amount,
        })
        .then(() => {
          product.saved = true;
          product.quantidade = product.new_amount;
          this.$forceUpdate();
        })
        .catch(() => {
          product.error = true;
          this.$forceUpdate();
        });
    },
    getLineClass(item, idx) {
      let resp = "";
      resp += this.getSpecialBackground(idx);
      if (item.focused == true) resp += " active";
      return resp;
    },
    closeNewProductModal() {
      this.showNewProductModal = false;
      this.new_product = null;
    },
    async loadGiro() {
      if (!this.storeNumber) return;

      const request = ++this.giroRequest;
      const codes = this.my_products
        .map((product) => suggestionCodeKey(product.pro_codInterno))
        .filter((code) => code !== "");

      this.giroByCode = {};
      this.giroFailed = false;

      if (!codes.length) {
        this.giroLoading = false;
        return;
      }

      this.giroLoading = true;

      try {
        const response = await new MiraiService(this.clientId).suggestion({
          storeNumber: String(this.storeNumber),
          internalCodes: codes,
          algoritmo: this.giroAlgoritmo,
        });
        if (request !== this.giroRequest) return;

        const byCode = {};
        (response.data.data || []).forEach((row) => {
          byCode[suggestionCodeKey(row.internal_code)] = row;
          if ("giro" in row) this.hasGiro = true;
        });
        this.giroByCode = byCode;
      } catch (error) {
        if (request === this.giroRequest) this.giroFailed = true;
      } finally {
        if (request === this.giroRequest) this.giroLoading = false;
      }
    },
    giroRow(item) {
      const code = suggestionCodeKey(item.pro_codInterno);
      return code ? this.giroByCode[code] || null : null;
    },
    giroSuggestion(item) {
      return this.formatGiroNumber(suggestionQuantity(item, this.giroRow(item), this.giroAlgoritmo));
    },
    giroEmptyReason(item) {
      if (!suggestionCodeKey(item.pro_codInterno)) return "Produto sem código interno";
      if (this.giroFailed) return "Não foi possível carregar o giro";
      return "Sem dados de giro nesta loja";
    },
    formatGiroNumber(value) {
      if (value === null || value === undefined || value === "") return "—";
      const num = Number(value);
      return isNaN(num) ? "—" : num.toLocaleString("pt-BR", { maximumFractionDigits: 2 });
    },
  },
  computed: {
    ...mapState(["whitelabel"]),
    giroAlgoritmo() {
      return buildSuggestionAlgoritmo({});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/sass/commons/_variables";
body {
font-family: $font-dm !important;
}
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  overflow-y: auto;
}
.modal-content-container {
  background-color: #fff;
  border-radius: 12px;
  width: 100vw;
  min-height: 110vh;
}
.ressuply-products__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1vw;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}
.ressuply-products__header-title {
  color: #ffffff;
  display: flex;
  align-items: center;
  letter-spacing: -2%;
  font-weight: 500;
  font-size: 2em;
}
.ressuply-products__closebtn-icon {
  color: #ffffff;
  font-size: 2.5em;
  cursor: pointer;
}

.ressuply-products__actions__container {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 1.5vh 2vw;
}
.ressuply-products__actions__div2-container {
  display: flex;
  align-items: center;
}
.ressuply-products__actions__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1vw;
  margin-left: 1vw;
  width: 12vw;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  background-color: #fafafc;
  cursor: pointer;
}
.ressuply-products__actions-icon {
  color: var(--primary-color);
  margin-right: 1rem;
}
.ressuply-products__actions-title {
  font-weight: 400;
  font-size: 1.1vw;
  letter-spacing: 2%;
  color: #505050;
}
.ressuply-products__table2-container {
  margin: 1vh 2vw;
  overflow-x: auto;
  max-height: 70vh;
}
.ressuply-products__table-thead-tr {
  background-color: #fffefc;
  border: 0.5px solid #e5e5e5;
  color: #605f5f;
  font-weight: 400;
}
.ressuply-products__table-td {
  font-family: Rubik;
  color: #605f5f;
  font-size: 1em;
  font-weight: 300;
}
.ressuply-products__edit-amount-wrapper {
  display: flex;
  align-items: center;
}
.ressuply-products__edit-amount-icon {
  color: #fff;
  background-color: #e5e5e5;
  border: 1.5px solid #e5e5e5;
  border-radius: 0px 5px 5px 0px;
  cursor: pointer;
}
.focused-input:focus-visible + .ressuply-products__edit-amount-icon {
  background-color: var(--primary-color);
}
.product-amount {
  border-radius: 5px 0px 0px 5px;
  border: 2px solid #e5e5e5;
  width: 50%;
  text-align: center;
  outline: none;
}
.product-amount.active {
  background-color: #9fff9f73;
  color: green;
}
.ressuply-products__giro-empty {
  color: #bfbfbf;
}
.ressuply-products__giro-suggestion {
  font-weight: 500;
  cursor: default;
}
.show-print {
  display: none;
}

.ressuply-products__search-product__container {
  margin: 1vh 2vw;
}

.ressuply-products__search-product__input-wrapper {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
}
.ressuply-products__search-product__input-container {
  display: flex;
  align-items: center;
}
.ressuply-products__search-product__search-icon {
  position: relative;
  font-size: 2em;
  left: -40px;
  cursor: pointer;
  color: #898989;
}
.ressuply-products__search-product__search-input {
  width: 25vw;
  color: #a1a1a1;
  font-weight: 400;
  font-size: 1.2em;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  padding: 1vw;
}

.ressuply-products__search-product__search-title {
  color: #898989;
  font-size: 1.5em;
  font-weight: 400;
  letter-spacing: 0.15px;
  margin-bottom: 0.5vh;
}
.active {
  background-color: #9fff9f73;
  color: black;
  border-color: #9fff9f73;
}
.error {
  background-color: #ff000059;
  color: white;
  border-color: #ff000059;
}
.focused-input:focus {
  border: 1.5px solid var(--primary-color);
}
.page-table-line-special {
  background: #f7f7f7;
}

.mobile {
  display: none;
}

@media only screen and (max-width: 750px) {
  .mobile {
    display: flex;
  }
  .ressuply-products__table-container {
    max-height: 50vh;
    margin: 10px;
  }
  .ressuply-products__actions__container {
    flex-wrap: wrap;
  }
  .resupply-filter-select {
    width: 47%;
  }
  .ressuply-products__table2-container {
    max-height: 80vh;
    margin: 10px;
  }
  .modal-content-container {
    height: 100vh;
    width: 115vw;
  }
  .ressuply-products__actions__div2-container {
    justify-content: space-between;
    align-items: flex-start;
    margin: 0;
    width: 100%;
  }
  .ressuply-products__actions__div1-container {
    margin: 0px 5px;
  }
  .ressuply-products__search-product__input-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .ressuply-products__search-product__title-wrapper {
    margin-bottom: 0px;
    margin: 10px 0px;
  }
  .ressuply-products__search-product__add-title {
    font-size: 18px;
  }
  .ressuply-products__search-product__search-title {
    font-size: 16px;
  }
  .ressuply-products__search-product__input-container {
    margin-bottom: 5px;
    width: 100%;
  }
  .ressuply-products__search-product__search-input {
    width: 100%;
    font-size: 12px;
  }
  .ressuply-products__actions-title {
    font-size: 14px;
  }
  .ressuply-products__actions-icon {
    font-size: 14px;
  }
  .ressuply-products__actions__wrapper {
    margin: 5px 0px;
    width: 48%;
  }
  .ressuply-products__header-title {
    font-size: 20px;
  }
  .ressuply-products__search-product__container {
    margin: 0px 5px;
    width: 100%;
  }
  .mobile-buttons-container {
    flex-wrap: wrap;
  }
  .resupply-check-container {
    font-size: 1.4em;
  }
  .mobile-name-row {
    font-size: 1.3em;
    font-weight: bold;
    margin-bottom: 1vh;
    gap: 4vw;
  }
  .mobile-center {
    text-align: center;
  }
  .mobile-end {
    text-align: end;
  }
  .mobile-table-title {
    font-size: 1.1em;
    font-weight: bold;
    margin: 0;
  }
  .mobile-table-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5vh;
    font-size: 1.3em;
  }
  .product-amount {
    width: 100%;
  }
  .mobile-input-size {
    width: 30%;
  }
  .ressuply-products__table-container {
    max-height: 70vh;
  }
  .ressuply-more-line {
    width: 30vw;
  }
  .ressuply-more-container {
    right: -18vw;
    top: 1vh;
  }
  .desktop {
    display: none !important;
  }
}

@media print {
  .ressuply-products__table-pack-width {
    width: 5%;
  }
}

.active {
  background-color: #9fff9f73;
  color: black;
  border-color: #9fff9f73;
}
.error {
  background-color: #ff000059;
  color: white;
  border-color: #ff000059;
}

</style>
